import React from 'react';
import { useFormGeneratorField } from '../hooks/useFormGeneratorField';
import FormError from './FormError';
import UniRadioItem from './UniRadioItem';

const UniRadioGroup = (props) => {
  const {
    warningtip,
    valueToDisplay,
  } = useFormGeneratorField(props);

  let params = {};
  if (props.params) {
    params = props.params;
  }
  let name = 'unnamed';
  if (typeof params.name === 'string' && params.name !== '') {
    name = params.name;
  }
  let formState = {};
  if (props.formState) {
    formState = props.formState;
  }
  let formErrors = {};
  if (props.formErrors) {
    formErrors = props.formErrors;
  }
  let handleChange = props.handleChange;
  if (typeof handleChange !== 'function') {
    handleChange = () => { };
  }

  let _handleChange = (e) => {
    // console.log('*** menjamo SELECT');
    if (params.valuetype === "number") {
      let _value;
      if (params.integer === true) {
        _value = Number.parseInt(e.target.value); // INTEGER
      } else {
        _value = Number.parseFloat(e.target.value); // FLOAT DEFAULT
      }
      let virtual_e = {
        target: {
          name: e.target.name,
          value: _value
        }
      }
      // console.log(virtual_e);
      handleChange(virtual_e);
    } else {
      // console.log(e);
      handleChange(e);
    }
  }

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  let cl = 'uniformcompo__field' + extraClass;
  if (typeof formErrors[name] === 'string' && formErrors[name] !== '') {
    cl += ' error';
  }

  if (params.outline === false) {
    cl += ' ' + 'uniformcompo__field--no-outline';
  } else if (params.outline === true) {
    cl += ' ' + 'uniformcompo__field--outline';
  }

  let style = {};
  if (params.w > 0) {
    style = {
      width: params.w
    };
  }

  // options
  let list = params.options;
  // let jsxRadioItems = null;


  let infotip = 'name: ' + name;
  if (params.valuetype === "number") {
    infotip = 'name: ' + name + ' (number)';
  }

  return (
    <div className={cl} style={style}>
      <label className="uniformcompo__radio-group__label">{params.label}</label>
      <FormError error={null} />
      <div className="uniformcompo__field__infotip-container"><div className="uniformcompo__field__infotip">{infotip}</div></div>
      {
        warningtip ? (
          <div className="uniformcompo__field__warningtip-container"><div className={"uniformcompo__field__warningtip" + (" frfr-js-tinytag frfr-js-tinytag--primitive-value-type--" + warningtip)}>{warningtip}</div></div>
        ) : null
      }
      <div className="uniformcompo__radio-group">
        {
          Array.isArray(list) ? (
            list.map((item) => {
              let value, title, tooltip;
              if (typeof item === 'string') {
                value = item;
                title = item;
                tooltip = null;
              } else {
                value = item.value;
                title = item.title;
                tooltip = item.tooltip;
              }
              return (
                <UniRadioItem
                  key={value}
                  name={name}
                  value={value}
                  title={title}
                  tooltip={tooltip}
                  formState={formState}
                  handleChange={_handleChange}
                />
              );
            })
          ) : null
        }
      </div>
    </div>
  );
};

export default UniRadioGroup;